export default "__VITE_ASSET__CCsuPMuM__"